import initialState from "./initialState";
import { FEATURED_BOOK, SEARCH_KEYWORD } from "./actionTypes";

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FEATURED_BOOK:
      return {
        ...state,
        featuredFilter: action.payload,
      };

    case SEARCH_KEYWORD:
      return {
        ...state,
        keyword: action.payload,
      };

    default:
      return state;
  }
}
